/** Zona horaria de referencia del negocio (España peninsular). El día del
 * evento y el «hoy» con el que se compara son ambos días de calendario en
 * España, no en UTC ni en la zona del servidor que renderiza — así dos clientes
 * en husos distintos nunca ven estados distintos para el mismo evento
 * (specs/019-estados-compra-eventos, edge cases). */
export const SPAIN_TIME_ZONE = 'Europe/Madrid'

/** Nombres de mes en español, índice 0 = enero. Compartido por
 * `formatPurchaseDate` (nombre completo, "12 de septiembre") y por
 * `formatEventDateTabla` del módulo `ProductosTabla` (abreviatura de 3 letras,
 * `.slice(0, 3)` — las 3 primeras letras de cada nombre en español coinciden
 * con su abreviatura habitual: "enero"→"ene", "septiembre"→"sep", etc. —
 * specs/037-productos-tabla/research.md §3). */
export const MONTH_NAMES = [
  'enero',
  'febrero',
  'marzo',
  'abril',
  'mayo',
  'junio',
  'julio',
  'agosto',
  'septiembre',
  'octubre',
  'noviembre',
  'diciembre',
]
